import React                     from 'react';
import classnames                from 'classnames';
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome';

import PartMessage               from './PartMessage'

const PartEmptyOption = (props) => {
  return(
    <React.Fragment key={"empty-vendor-" + props.offer_id + "-" + props.quantity}>
      <td 
       className={`option ${(props.quantity == props.selected_quantity) ? "activate" : ""}`} 
       data-num-board={props.quantity}
       rowSpan={props.rowspan}
       colSpan="4">
          <PartMessage 
            offer_id = {props.offer_id}
            selected_quantity = {props.selected_quantity}
            onViewMore = {props.onViewMore}
            status = {props.status}
            others = {props.others} />
      </td>
    </React.Fragment>
  )
} 

export default PartEmptyOption;